import React from "react";

export function Footer() {

    return (
        <footer className="login-page__footer">
            <span className="login-page__version">
                &copy; 2025 Tzion MyResult 2026.002.01.03
            </span>
        </footer>
    );
}